import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class CommonService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getDashboardCounters(page: number, pageSize: number = 10, filter: any): Observable<any> {
        let url = `Common/GetDashboardCounters`;
        return super.getAll<any>(url);
    }

    public getAllUserRoles(): Observable<any> {
        let url = `Common/GetAllUserRoles`;
        return super.getAll<any>(url);
    }

    public getDashboardLogCounters(): any {
        let url = `Common/GetDashboardLogCounters`;
        return super.getAll<any>(url);
    }

    public getMostRecentLogs(): any {
        let url = `Common/GetMostRecentLogs`;
        return super.getAll<any>(url);
    }

    public getErrorLogs(): Observable<IPagedResults<any>> {
        let url = `Common/GetErrorLogs`;
        return super.getAll<any>(url);
    }

    public getAllLanguages(): any {
        let url = `Common/GetAllLanguages`;
        return super.getAll<any>(url);
    }

    public getAllActiveModules(): any {
        let url = `Common/GetAllActiveModules`;
        return super.getAll<any>(url);
    }

    public getAllTenantTypes(id?: number): any {
        let url = `Common/GetAllTenantTypes?accountId=${id}`;
        return super.getAll<any>(url);
    }

    public getAllPremiseTypes(id?: number): any {
        let url = `Common/GetAllPremiseTypes?accountId=${id}`;
        return super.getAll<any>(url);
    }

    public getAllSubPremiseTypes(id?: number): any {
        let url = `Common/GetAllSubPremiseTypes?accountId=${id}`;
        return super.getAll<any>(url);
    }

    public getAllJobTitles(id?: number): any {
        let url = `Common/GetAllGetJobTitles?accountId=${id}`;
        return super.getAll<any>(url);
    }

    public guidtoint(data: any): Observable<any> {
        let url = `Common/GuidToInt?value=${data}`
        return super.getAll<any>(url)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts